// Photo 페이지 구현은 feature 폴더(`src/photo/`)로 완전히 이동했습니다.
// 기존 라우팅/임포트 호환을 위해 wrapper만 유지합니다.
import Photo from '../photo/pages/Photo';

export default Photo;


